import script from "./FloatingButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingButton.vue?vue&type=script&setup=true&lang=js"

import "./FloatingButton.vue?vue&type=style&index=0&id=02e4e4aa&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Vue-Projects\\ForestPage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02e4e4aa"]])

export default __exports__